export default {
    install: function(Vue) {
        Vue.filter('toCurrency', (value) => {
            if (isNaN(parseFloat(value))) {
                return value
            }
            let formatter = new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: 'GBP',
                minimumFractionDigits: 2
            });
            return formatter.format(parseFloat(value));
        });

        Vue.filter('toLowCurrency', (value) => {
            if (isNaN(parseFloat(value))) {
                return value
            }
            let formatter = new Intl.NumberFormat('en-GB', {
                style: 'currency',
                currency: '',
                minimumFractionDigits: 2
            });
            return formatter.format(parseFloat(value)) + 'p';
        });

        Vue.filter('numberFormat', (value) => {
            if (isNaN(parseFloat(value))) {
                return value
            }
            let formatter = new Intl.NumberFormat('en-GB', {
                style: 'decimal',
            });
            return formatter.format(parseFloat(value));
        });

        Vue.filter('roundYear', (value) => {
            return Math.floor(value);
        });

        Vue.filter('cleanModel', (value, range) => {
            let pattern = new RegExp('(' + range + ')|(PETROL|DIESEL)', 'g');
            return value.replace(pattern, '');
        });

        Vue.filter('cleanFuelType', (value) => {
            return value.replace(' CAR', '').replace(' LCV', '');
        });

        Vue.filter('ucFirst', (value) => {
            if (typeof value !== 'string') {
                return value;
            }
            return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
        });

        Vue.filter('subscript', (value) => {
            if (typeof value !== 'string') {
                return value;
            }
            let replacements = [
                {
                    pattern: new RegExp(/(CO2)/, 'ig'),
                    replacement: 'CO<sub>2</sub>'
                }
            ];

            replacements.forEach(function (match) {
                value = value.replace(match.pattern, match.replacement);
            });

            return value;
        });

        Vue.filter('bodyStyles', (value) => {
            if (typeof value !== 'string') {
                return value;
            }

            value = value.trim();

            let replacement = {
                '4x4': 'SUV',
                'Van': 'Vans (SWB/MWB)',
                'High Volume/High Roof Van': 'Vans (LWB/MAXI)',
            };

            if (replacement.hasOwnProperty(value)) {
                value = replacement[value];
            }

            return value;
        });
    }
}